import { SearchInput } from '@ui/components/SearchInput';
import styles from './LeadersModal.module.css';
import { LeaderboardType } from '@features/landing/grandprix/typings';

type Props = {
  query: string;
  onQueryChange: (value: string) => void;
  leaderboardType: LeaderboardType;
};

export function LeadersModalSearch({
  query,
  onQueryChange,
  leaderboardType,
}: Props) {
  return (
    <SearchInput
      query={query}
      onQueryChange={onQueryChange}
      className={styles.searchInput}
      placeholder={
        leaderboardType === 'girls'
          ? 'Поиск по участницам'
          : 'Поиск по участникам'
      }
    />
  );
}
